import React from "react";
import s from "./stepper.scss";
import cx from "classnames";
import _ from "lodash";
import ButtonBack from "Components/buttonBack/ButtonBack";

export default function Stepper({ active, goBack, steps, hideBackOnSteps = [] }) {
  return (
    <div className={cx("stepsFP", s.stepper)}>
      {active > 1 && !hideBackOnSteps.includes(active) && <ButtonBack className={s.stepBtnBack} onClick={goBack} />}
      <div className={cx(s.wrapSteps, s.active)}>
        {_.times(steps, (i) => {
          i = parseInt(i) + 1;
          return (
            <div
              key={i}
              className={cx(s.step, {
                [s.active]: active > i || active === i,
              })}
            />
          );
        })}
      </div>
    </div>
  );
}
